module.exports = __webpack_public_path__ + "static/media/candies5.f1003d91.png";